module.exports = __webpack_public_path__ + "img/vn.c4f7fdb3.svg";